export const IS_PRODUCTION = window.location.origin === 'https://app.shine.fr';
